// All values are stored in metric units (bar, mm, liters).
// These functions convert between metric and display units.

const BAR_TO_PSI    = 14.5038;
const BAR_TO_KPA    = 100;
const LITER_TO_GAL_US = 1 / 3.78541;
const LITER_TO_GAL_UK = 1 / 4.54609;
const MM_TO_INCH    = 1 / 25.4;

// --- Pressure (bar <-> psi) ---

export function barToDisplay(bar: number | undefined, unit: 'bar' | 'psi' | 'kpa'): number | undefined {
  if (bar == null) return undefined;
  if (unit === 'psi') return Math.round(bar * BAR_TO_PSI * 10) / 10;
  if (unit === 'kpa') return Math.round(bar * BAR_TO_KPA);
  return bar;
}

export function displayToBar(value: number | undefined, unit: 'bar' | 'psi' | 'kpa'): number | undefined {
  if (value == null) return undefined;
  if (unit === 'psi') return Math.round(value / BAR_TO_PSI * 1000) / 1000;
  if (unit === 'kpa') return Math.round(value / BAR_TO_KPA * 1000) / 1000;
  return value;
}

// --- Volume (liters <-> gallons) ---

export function litersToDisplay(liters: number | undefined, unit: 'liters' | 'gallons_us' | 'gallons_uk'): number | undefined {
  if (liters == null) return undefined;
  if (unit === 'gallons_us') return Math.round(liters * LITER_TO_GAL_US * 100) / 100;
  if (unit === 'gallons_uk') return Math.round(liters * LITER_TO_GAL_UK * 100) / 100;
  return liters;
}

export function displayToLiters(value: number | undefined, unit: 'liters' | 'gallons_us' | 'gallons_uk'): number | undefined {
  if (value == null) return undefined;
  if (unit === 'gallons_us') return Math.round(value * 3.78541 * 100) / 100;
  if (unit === 'gallons_uk') return Math.round(value * 4.54609 * 100) / 100;
  return value;
}

// --- Length (mm <-> inch) — used for wiper blades ---

export function mmToDisplay(mm: number | undefined, unit: 'mm' | 'inch'): number | undefined {
  if (mm == null) return undefined;
  if (unit === 'inch') return Math.round(mm * MM_TO_INCH * 10) / 10;
  return mm;
}

export function displayToMm(value: number | undefined, unit: 'mm' | 'inch'): number | undefined {
  if (value == null) return undefined;
  if (unit === 'inch') return Math.round(value * 25.4);
  return value;
}

// --- Distance (km <-> miles) — values stored as km in DB ---

const KM_TO_MILES = 0.621371;

export function kmToDisplay(km: number | undefined, unit: 'km' | 'miles'): number | undefined {
  if (km == null) return undefined;
  if (unit === 'miles') return Math.round(km * KM_TO_MILES);
  return km;
}

export function displayToKm(value: number | undefined, unit: 'km' | 'miles'): number | undefined {
  if (value == null) return undefined;
  if (unit === 'miles') return Math.round(value / KM_TO_MILES);
  return value;
}

export function distanceUnitLabel(unit: 'km' | 'miles'): string {
  return unit === 'miles' ? 'mi' : 'km';
}

// --- Labels ---

export function volumeUnitLabel(unit: 'liters' | 'gallons_us' | 'gallons_uk'): string {
  if (unit === 'gallons_us') return 'gal (US)';
  if (unit === 'gallons_uk') return 'gal (UK)';
  return 'L';
}
